import { ContentModuleTypes, ContentModuleSubTypes, FolderAPIResoponse, Folder, IResponse, ContentModule, Lesson, Portfolio, AccessTypeSystemCode } from '@DavisDigital/interfaces';
import { ApiService } from '@DavisDigital/davisdigitalfrontend.module';

export class ContentService {
	
	private accountSharerList: any = {};
	
	//@ngInject
	constructor( 
		private $http      : ng.IHttpService,
		private $q         : ng.IQService,
		private apiService : ApiService
	) {}
	
	public updateSortOrder = (contentModules) =>{
		
		let deferred = this.$q.defer();
		
		if(contentModules.length === 0) return deferred.promise;
		
		let data:any = {
			contentModules: contentModules
		}
		
		this.apiService.request( 'davisdigital:api.updateContentModuleSortOrder', data).then( result => {
			deferred.resolve( result.data );
		}).catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	}
	
	public newContentModule = (contentModuleType: ContentModuleTypes, position=0, bodyHtml='') =>{
		var contentModule:any = { 
			contentModuleType_systemCode : contentModuleType,
			sortOrder : position + 1,
			editing : true,
			bodyHTML : bodyHtml
		};
		
		if(contentModuleType === ContentModuleTypes.EMBEDDED){
			contentModule.contentModuleCreated=false;
		}
		if(contentModuleType === ContentModuleTypes.IMAGE){
			contentModule.contentModuleSubType_systemCode = ContentModuleSubTypes.GRID;
		}
		
		if(contentModuleType === ContentModuleTypes.SPLIT ){
			contentModule.splitImageLeftFlag = true; 
			contentModule.splitLayoutImage_imageID = undefined;
		}
		
		return contentModule;
	}
	
	public saveContentModule = (contentModule) : ng.IPromise<any> => {
		let deferred = this.$q.defer<any>();
		
		let data:any = {
			contentModuleID : contentModule.contentModuleID,
			contentModule : contentModule
		} 
		
		this.apiService.request( 'davisdigital:api.saveContentModule', data).then( result => {
			deferred.resolve( result.data );
		}).catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	}
	
	public deleteContentModule = (contentModule) : ng.IPromise<any> => {
		let deferred = this.$q.defer<any>();
		
		let data:any = {
			contentModuleID: contentModule.contentModuleID
		}
		
		this.apiService.request( 'davisdigital:api.deleteContentModule', data).then( result => {
			deferred.resolve( result.data );
		}).catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	}
	
	public copyContentModule = (contentModule: ContentModule, lesson: Lesson, portfolio: any) : ng.IPromise<any> => {
		let deferred = this.$q.defer<any>();
		
		let data:any = {
			contentModuleID: contentModule?.contentModuleID,
			lessonID: lesson?.lessonID,
			portfolioID: portfolio?.portfolioID
		}
		
		this.apiService
		.request('davisdigital:api.copyContentModule', data)
		.then( (result) => deferred.resolve(result.data) )
		.catch(deferred.reject);
		
		return deferred.promise;
	}
	
	public uploadFileToContentModule = (file, contentModule, primaryID, entityName) =>{
		
		
		var formData = new FormData();

		formData.append( "downloadFile", file);
		formData.append( "contentModule", angular.toJson(contentModule) );
		formData.append( `${entityName}ID`, primaryID);

		return this.$http.post(
			this.apiService.getEndpoint('davisdigital:api.uploadFileToContentModule'),
			formData,
			{
				headers: { 'Content-Type': undefined },
        		transformRequest: angular.identity
			}
		)
	}
	
	
	/**
	 * Create a New Folder
	 * 
	 * @param title
	 * @return {Promise}
	 **/
	public createFolder = ( title : string, folderType: string ): ng.IPromise<FolderAPIResoponse> => {
		
		let deferred = this.$q.defer<FolderAPIResoponse>();
		let slatAction = 'davisdigital:api.createFolder';
		let data = {'title': title, "folderType": folderType};

		this.apiService.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	/**
	 * Update a Folder
	 * 
	 * @param folder
	 * @return {Promise}
	 **/
	public updateFolder = ( folder: Folder): ng.IPromise<IResponse<any>> => {
		let deferred = this.$q.defer<IResponse<any>>();

		let data: any = {
			title: folder.title,
			folderID: folder.folderID,
			folderType_systemCode: folder.folderType_systemCode
		};
		this.apiService
			.request('davisdigital:api.updateFolder', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
    /**
	 * Delete Folder
	 *
	 * @param title
	 * @return {Promise}
	 **/
	public deleteFolder = (folderID: string): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.deleteFolder';
		let data = { folderID: folderID};

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public getAccountsListForShare(args): ng.IPromise<any> {
		let deferred = this.$q.defer();

		let data: any = {};

		if (args?.folderID?.trim()) {
			data.folderID = args.folderID;
		} 
		else if (args?.portfolioID?.trim()) {
			data.portfolioID = args.portfolioID;
		}
		else if (args?.lessonID?.trim()) {
			data.lessonID = args.lessonID;
		}
		
		if(args?.shareWithoutAccessOnly) {
			data.shareWithoutAccessOnly = args.shareWithoutAccessOnly;
		}
		
		if(args?.ignoreStudentAccounts) {
			data.ignoreStudentAccounts = args.ignoreStudentAccounts;
		}
		
		if(args?.ignoreAdminAccounts) {
			data.ignoreAdminAccounts = args.ignoreAdminAccounts;
		}

		this.apiService
			.request('davisdigital:api.getAccountsListForShare', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public getAccountsListForShareWithTag(args): ng.IPromise<any> {
		let deferred = this.$q.defer();

		let data: any = {};
		
		if(args?.accountIDList) {
			data.accountIDList = args.accountIDList;
		}
		
		if(args?.tagName) {
			data.tagName = args.tagName;
		}

		this.apiService
			.request('davisdigital:api.getAccountsListForShareWithTag', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	public removeAccountAccessForShare(baseObjectID:string, accountID?:string ): ng.IPromise<any> {
		let deferred = this.$q.defer();

		let data: any = {
			accountID: accountID,
			baseObjectID: baseObjectID,
		};

		this.apiService
			.request('davisdigital:api.removeAccountAccessForShare', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};

	public assignAccountShareAccess(
		accountID: string, 
		baseObjectID: string, 
		access: AccessTypeSystemCode, 
		type: string, 
		shareType: number = 0
	): ng.IPromise<any> {
		let deferred = this.$q.defer();

		let data: any = {
			accountID: accountID,
			baseObjectID: baseObjectID,
			accessTypeCode: access ? access : 'accountAccessRead',
			objectType: type,
			shareType: shareType
		};

		this.apiService
			.request('davisdigital:api.assignAccountShareAccess', data, 'POST')
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public assignAccountBulkShareAccess(accountIDs, baseObjectID, access, type): ng.IPromise<any> {
		let deferred = this.$q.defer();

		let data: any = {
			accountIDList: accountIDs,
			baseObjectID: baseObjectID,
			accessTypeCode: access ? access : 'accountAccessRead',
			objectType: type,
		};

		this.apiService
			.request('davisdigital:api.assignAccountBulkShareAccess', data, 'POST')
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public removeBulkShareAccess(baseObjectID:string): ng.IPromise<any> {
		let deferred = this.$q.defer();

		let data: any = {
			baseObjectID: baseObjectID,
		};

		this.apiService
			.request('davisdigital:api.removeAccountBulkShareAccess', data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public getSharerAccountList(objectType: string, shareType :number = 0, burstCache: boolean = false): ng.IPromise<any> {
		let deferred = this.$q.defer();
		
		if(burstCache) {
			this.accountSharerList = {};
		}
		
		let cacheKey = `shareAccountList-${JSON.stringify(objectType)}`;
		
		if (this.accountSharerList[cacheKey]) {
			deferred.resolve(this.accountSharerList[cacheKey]);
			return deferred.promise;
		}
		
		this.apiService
			.request('davisdigital:api.getSharerAccountList', {
				objectType: objectType,
				shareType: shareType,
			})
			.then((result) => {
				this.accountSharerList[cacheKey] = result.data;
				deferred.resolve(this.accountSharerList[cacheKey]);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
	};
	
	public getClassListForShare(): ng.IPromise<any> {
		let deferred = this.$q.defer();
		
		this.apiService.request(
		    'davisdigital:api.getClassListForAccount'
		)
		.then((result) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});

		return deferred.promise;
	}

    public shareWithClass(baseObjectID: string, objectType: string, classID: string ): ng.IPromise<any> {
        let deferred = this.$q.defer();
		
		this.apiService.request(
		    'davisdigital:api.shareResourceWithClass', 
			{ 
				baseObjectID: baseObjectID, 
				objectType: objectType,
				schoolCourseID: classID
			},
			'POST'
		)
		.then((result) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});

		return deferred.promise;
    }
    
    /**
     * Method to update share settings for portfolio
     * */
    public shareSettingsUpdate(portfolioID: string, sharedWithDistrict: string, sharedWithPublic: string, publicURL: string ): ng.IPromise<any> {
        let deferred = this.$q.defer();
		
		this.apiService.request(
		    'davisdigital:api.shareSettingsUpdate', 
			{ 
				portfolioID: portfolioID,
				sharedWithPublic: sharedWithPublic, 
				sharedWithDistrict: sharedWithDistrict,
				publicURL: publicURL,
			},
			'POST'
		)
		.then((result) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});

		return deferred.promise;
    }
    
    public exportLessons(lessonIDs: string, downloadType: string, downloadNowFlag: boolean = false, emailAddress: string = "", folderID: string = "" ): ng.IPromise<any> {
        let deferred = this.$q.defer();
		
		let data: any = { 
			lessonID: lessonIDs, 
			downloadType: downloadType,
			downloadNowFlag: downloadNowFlag,
		};
		
		//Add email address only when passed, server will handle default value
		if( emailAddress != "") {
			data.emailAddress = emailAddress;
		}
		
		if( folderID != "") {
			data.folderID = folderID;
		}
		
		this.apiService.request(
		    'davisdigital:api.exportLessons', 
			data,
			'POST'
		)
		.then((result) => {
			deferred.resolve(result);
		})
		.catch((result) => {
			deferred.reject(result);
		});

		return deferred.promise;
    }
    
    public exportPortfolios(portfolioIDs: string, downloadType: string, downloadNowFlag: boolean = false, emailAddress: string = "", folderID: string = "" ): ng.IPromise<any> {
        let deferred = this.$q.defer();
		
		let data: any = { 
			portfolioID: portfolioIDs, 
			downloadType: downloadType,
			downloadNowFlag: downloadNowFlag,
		};
		
		//Add email address only when passed, server will handle default value
		if( emailAddress != "") {
			data.emailAddress = emailAddress;
		}
		
		if( folderID != "") {
			data.folderID = folderID;
		}
		
		this.apiService.request(
		    'davisdigital:api.exportPortfolios', 
			data,
			'POST'
		)
		.then((result) => {
			deferred.resolve(result);
		})
		.catch((result) => {
			deferred.reject(result);
		});

		return deferred.promise;
    }
    
    public saveArchive(baseObjectID: string, objectType: string, archiveAction:boolean = true ) : ng.IPromise<any>  {
		
		var lessonID = "";
		var folderID = "";
		
		if( objectType == "lesson") {
			lessonID = baseObjectID;
		} else if(objectType == "folder") {
			folderID = baseObjectID;
		}
		
		let deferred = this.$q.defer();

		let slatAction = 'davisdigital:api.saveArchive';

		let data = { lessonID: lessonID, folderID: folderID, archiveAction: archiveAction };

		this.apiService
			.request(slatAction, data)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});

		return deferred.promise;
    }
    
    public getDavisAccountType = (): ng.IPromise<any> => {
		
		let deferred = this.$q.defer();

		this.apiService.request('davisdigital:api.getDavisAccountType').then( result => {
			deferred.resolve( result.data.data );
		}).catch( result => {
			deferred.reject( result );
		});

		return deferred.promise;
	}

	public getCMSContent = (urlTitlePath: string, contentProperty: string = 'contentBody'): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		this.apiService.request(`davisdigital:api.getCMSContent`, {urlTitlePath:urlTitlePath,contentProperty:contentProperty}).then( result => {
			deferred.resolve( result.data.data );
		}).catch( result => {
			deferred.reject( result );
		});

		return deferred.promise;
	}
	
	public saveAgreementPrivacyCompliance = (): ng.IPromise<any> => {
		let deferred = this.$q.defer();

		this.apiService.request(`davisdigital:api.saveAgreementPrivacyCompliance`).then( result => {
			deferred.resolve( result.data.success );
		}).catch( result => {
			deferred.reject( result );
		});

		return deferred.promise;
	}
}